import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import Drawer from "../../../../../components/Drawer";
import Table from "../../../../../components/NTable";
import DateInput from "../../../../../components/Inputs/DateInput";
import { useNewTable } from "../../../../../components/NTable/hook";
import Button from "../../../../../components/Button";
import ResourceSelect from "../../../../../components/Inputs/ResourceSelect";
import { useColumns } from "./useColumns";
import { useHistoryApi } from "../../../helpers/historyHelpers/api";
import { firstToUpper } from "../../../../../utils/helpers/string";
import { getSettingsResourceSearchFilters, renderSettingsResourceLabel } from "../../../../../utils/helpers/settings";
import { renderUserName } from "../../../../../utils/helpers/user";
import { getUserSearchFilters } from "../../../../People/useColumns";
import "./style.scss";

function HistoryDrawer({ open, close, id }) {
    const { t } = useTranslation();
    const columns = useColumns();
    const [filters, setFilters] = useState({
        year: moment().year(),
    });
    const [error, setError] = useState(null);

    const { getHistory, data, totalItems, loading } = useHistoryApi();

    const onStartDateChange = useCallback(
        (value) => {
            setFilters((prev) => ({ ...prev, from: moment(value).year(filters.year) }));
            setError(null);
        },
        [filters.year]
    );

    const onEndDateChange = useCallback((value) => {
        if(!filters?.from) {
            setError(t("required-from"))
        } else {
            setFilters((prev) => ({ ...prev, to: moment(value).year(filters?.year) }))
            setError(null);
        }
    }, [filters?.from, filters?.year, t])

    const table = useNewTable({
        data,
        totalItems,
        columns,
        enableRowSelection: false,
        loading,
    });

    const { pagination } = table.getState();

    useEffect(() => {
        const controller = new AbortController();

        const params = {
            entity: "calculation-group",
            from: filters?.from && moment(filters?.from).format("YYYY-MM-DD"),
            to: filters?.to && moment(filters?.to).format("YYYY-MM-DD"),
            page: pagination.pageIndex + 1,
            perPage: pagination.pageSize,
        };                        

        if(id) {
            params.entityId = id
        }

        getHistory(params, controller);
        return () => controller.abort();
    }, [getHistory, pagination, id, filters?.from, filters?.to]);

    const clearFilters = useCallback(() => {
        setFilters({ year: moment().year() });
    }, []);

    return (
        <Drawer className="settings-history-drawer" title={t("history")} open={open} close={close}>
            {/* <div className="d-flex gap-2 mt-2 mb-4">
                <div className="w-100">
                    <DateInput
                        placeholderText={t("from")}
                        onChange={onStartDateChange}
                        value={filters?.from && moment(filters.from).toDate()}
                    />
                </div>
                <div className="w-100">
                    <DateInput
                        placeholderText={firstToUpper(t("to"))}
                        onChange={onEndDateChange}
                        value={filters?.to && moment(filters.to).toDate()}
                    />
                </div>
                <div className="w-100">
                    <ResourceSelect 
                        labelPropName="name"
                        resourcePath="/users"
                        placeholder={t("users")}
                        renderLabel={renderUserName}
                        getSearchFilters={getUserSearchFilters}
                        hasSearch
                    />
                </div>
                <div className="w-100">
                    <ResourceSelect
                        labelPropName="description"
                        placeholder={t("calculation-group")}
                        renderLabel={renderSettingsResourceLabel}
                        resourcePath="/calculation-group"
                        hasSearch
                        mode="multiple"
                        getSearchFilters={getSettingsResourceSearchFilters}
                    />
                </div>
                <div>
                    <Button className="text-nowrap" color="primary" onClick={clearFilters}>
                        {t("clear-filters")}
                    </Button>
                </div>
            </div> */}
            <div>
                <Table table={table} />
            </div>
        </Drawer>
    );
}

export default HistoryDrawer;
